export const refreshData = bool => ({
    type: 'REFRESH_DATA',
    bool
})